import React, { useEffect } from 'react';
import { Routes, Route, Navigate, useParams } from 'react-router-dom';
import Login from '../component/Login/index';
import Register from '../component/Register/index';
import Layout from '../component/ui/Layout';
import ForgetPassword from '../component/ResetPassword/Email';
import ResetPassword from '../component/ResetPassword/RestoredPassword';

import CalculateVolumeStepper from '../component/CalculateVolumeStepper/index';
import VolumeCalculator from '../component/VolumeCalculator/index';
import { ThemeProvider } from '@material-ui/core/styles';
import theme from '../component/ui/theme';
import { useTranslation } from 'react-i18next';

const LanguageWrapper = ({ lang, element }) => {
	const { i18n } = useTranslation();

	useEffect(() => {
		// If a valid language prop is provided, use it, otherwise fallback to 'nl'
		const currentLang = lang || 'nl';
		if (i18n.language !== currentLang) {
			i18n.changeLanguage(currentLang);
		}
	}, [lang, i18n]);

	return element;
};

const CustomRouter = () => {
	return (
		<>
			<ThemeProvider theme={theme}>
				<Routes>
					<Route
						path='/offerte-aanvragen'
						element={
							<LanguageWrapper
								lang='nl'
								element={<CalculateVolumeStepper />}
							/>
						}
					/>
					<Route
						path='/calculate-volume'
						element={
							<LanguageWrapper
								lang='en'
								element={<CalculateVolumeStepper />}
							/>
						}
					/>
					<Route
						path='/furniture-calculate-volume'
						element={
							<LanguageWrapper
								lang='en'
								element={<VolumeCalculator />}
							/>
						}
					/>
					<Route
						path='/'
						element={
							<Navigate
								to='offerte-aanvragen'
								replace
							/>
						}
					/>
				</Routes>
			</ThemeProvider>
		</>
	);
};

export default CustomRouter;
